import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Container, Form, Button, Alert, Card, Spinner } from "react-bootstrap";
import Layout from "../layout";

const LogistikApprove = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [idKendaraan, setidKendaraan] = useState("");
  const [estimasiWaktuTiba, setEstimasiWaktuTiba] = useState("");
  const [waktuPengiriman, setWaktuPengiriman] = useState("");
  const [tanggalPengiriman, setTanggalPengiriman] = useState("");
  const [kendaraanOptions, setKendaraanOptions] = useState([]);
  const [msg, setMsg] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const productId = queryParams.get("productId");

  useEffect(() => {
    if (!productId) {
      setMsg("ID produk tidak ditemukan.");
      setMsgType("danger");
    }
  }, [productId]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(
          "https://c-greenproject.org:8000/idKendaraan/",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setKendaraanOptions(response.data);
      } catch (error) {
        setMsg("Gagal mengambil data kendaraan logistik.");
        setMsgType("danger");
      }
    };
    fetchData();
  }, []);

  const handleApprove = async (e) => {
    e.preventDefault();
    if (
      !idKendaraan ||
      !estimasiWaktuTiba ||
      !waktuPengiriman ||
      !tanggalPengiriman
    ) {
      setMsg("Semua data harus diisi");
      setMsgType("danger");
      return;
    }

    if (isNaN(Date.parse(tanggalPengiriman))) {
      setMsg("Penulisan data tidak sesuai");
      setMsgType("danger");
      return;
    }

    setLoading(true);
    const token = localStorage.getItem("token");
    const payload = {
      idKendaraan,
      estimasiWaktuTiba,
      waktuPengiriman,
      tanggalPengiriman,
      logistik: true,
    };
    try {
      await axios.patch(
        `https://c-greenproject.org:8000/products/${productId}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setMsg("Persetujuan logistik berhasil.");
      setMsgType("success");
      setTimeout(() => navigate("/order"), 2000);
    } catch (error) {
      setMsg(error.response?.data?.msg || "Gagal mengubah status logistik.");
      setMsgType("danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Container className="mt-4">
        <h2><strong>Logistik Approval Form</strong></h2>
        {msg && <Alert variant={msgType}>{msg}</Alert>}
        <Card className="shadow-sm p-4">
          <Form onSubmit={handleApprove}>
            <Form.Group className="mb-3">
              <Form.Label>Pilih Kendaraan</Form.Label>
              <Form.Select
                value={idKendaraan}
                onChange={(e) => setidKendaraan(e.target.value)}
              >
                <option value="">Pilih Kendaraan</option>
                {kendaraanOptions.map((kendaraan) => (
                  <option
                    key={kendaraan.idKendaraan}
                    value={kendaraan.idKendaraan}
                  >
                    {kendaraan.idKendaraan}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Tanggal Pengiriman</Form.Label>
              <Form.Control
                type="date"
                value={tanggalPengiriman}
                onChange={(e) => setTanggalPengiriman(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Waktu Pengiriman</Form.Label>
              <Form.Control
                type="time"
                value={waktuPengiriman}
                onChange={(e) => setWaktuPengiriman(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Estimasi Waktu Tiba</Form.Label>
              <Form.Control
                type="time"
                value={estimasiWaktuTiba}
                onChange={(e) => setEstimasiWaktuTiba(e.target.value)}
              />
            </Form.Group>

            <Button
              type="submit"
              variant="primary"
              disabled={loading}
              className="w-100"
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Setujui"}
            </Button>
          </Form>
        </Card>
      </Container>
    </Layout>
  );
};

export default LogistikApprove;
